import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Las peticiones de token no se interceptan
        if (req.body && req.body.indexOf('grant_type') > -1) {
            return next.handle(req);
        }
        if (req.url.indexOf('hereapi.com') > -1) {
            return next.handle(req);
        }
        const request = req.clone({
            setHeaders: {
                Authorization: `Bearer ${sessionStorage.getItem('tokenSSO')}`
            }
        });
        return next.handle(request);
    }
}
